import React from 'react'
import { useLanguage } from '../contexts/LanguageContext'

interface LanguageSelectorProps {
  compact?: boolean
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ compact = false }) => {
  const { language, setLanguage, isLoading } = useLanguage()

  const handleLanguageChange = (newLanguage: 'en' | 'fr') => {
    setLanguage(newLanguage)
  }

  if (compact) {
    return (
      <button
        onClick={() => handleLanguageChange(language === 'en' ? 'fr' : 'en')}
        disabled={isLoading}
        className="flex items-center space-x-1.5 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
        title={language === 'en' ? 'Switch to French' : 'Switch to English'}
      >
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span className="text-xs font-medium">{language.toUpperCase()}</span>
      </button>
    )
  }

  return (
    <button
      onClick={() => handleLanguageChange(language === 'en' ? 'fr' : 'en')}
      disabled={isLoading}
      className="flex items-center space-x-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
      title={language === 'en' ? 'Switch to French' : 'Switch to English'}
    >
      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className="text-sm font-medium">{language.toUpperCase()}</span>
    </button>
  )
}

export default LanguageSelector